import { combineReducers } from '@reduxjs/toolkit'
import UserReducer from './slicers/UserSlicer'
import ConfigReducer from './slicers/ConfigsSlicer'
import ModalReducer from './slicers/ModalSlicer'

// Import reducers here...
const rootReducer = combineReducers({
  config: ConfigReducer,
  modal: ModalReducer,
  user: UserReducer
})

export default rootReducer
